import React, { useState } from "react";
import { Field, TextField } from "components/commons";
import locale from "localization";
import styles from "./select-key-account.module.scss";
import { useModal } from "hooks";
import SelectKeyAccountModal from "components/modals/select-key-accounts/select-key-account-modal";
import { ArrowForwardIos, KeyboardArrowDown } from "@material-ui/icons";

const SelectKeyAccount = ({ fields, onChange }) => {
  const [selectedKeyAccount, setSelectedKeyAccount] = useState(null);
  const keyAccountCode = useModal();
  const keyAccountName = useModal();

  const handleSelectKeyAccount = (keyAccount) => {
    setSelectedKeyAccount(keyAccount);
    onChange("keyAccountId", { value: keyAccount.keyAccountId });
  };

  return (
    <>
      <div className={styles.row}>
        <Field {...fields} label={locale.keyAccountCode} childrenClassName={styles.fieldContent}>
          <TextField
            readOnly
            value={selectedKeyAccount?.code || ""}
            onClick={() => keyAccountCode.show()}
            suffix={<ArrowForwardIos className={styles.arrow} />}
            placeholder={locale.selectKeyAccountCode}
          />
        </Field>

        <Field {...fields} label={locale.keyAccountName} childrenClassName={styles.fieldContent}>
          <TextField
            readOnly
            value={selectedKeyAccount?.name || ""}
            onClick={() => keyAccountName.show()}
            suffix={<KeyboardArrowDown className={styles.arrowDown} />}
            placeholder={locale.selectKeyAccountName}
          />
        </Field>
      </div>

      <SelectKeyAccountModal type={"code"} {...keyAccountCode} onSelect={handleSelectKeyAccount} />
      <SelectKeyAccountModal type={"name"} {...keyAccountName} onSelect={handleSelectKeyAccount} />
    </>
  );
};

export default SelectKeyAccount;
